import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'

interface Props {
  open: boolean
  onYes: () => void
  onNo: () => void
}

export default function UnsavedChangesDialog(props: Props) {
  return (
    <Dialog open={props.open} onClose={props.onNo}>
      <DialogTitle>Unsaved changes</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to leave this page? Your unsaved changes will be lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onNo} color="primary">
          No
        </Button>
        <Button onClick={props.onYes} color="secondary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

